module.exports = __webpack_public_path__ + "static/vonSpradlin-4957d5cf315353771f8ad41d3362df6c.png";